import http from "../../http-common-admin";
import httpCandidatures from "../../http-common-candidatures";


class DepartamentoServices {

  getAll(universityID, facultyID, tipoDisplay){

    return http.get(`/departments?universityID=${universityID}&facultyID=${facultyID}&tipoDisplay=${tipoDisplay}`);
}

getAllTypeAvaliation(tipoDisplay, universityID, facultyID, departmentID){
    return http.get(`/departments?tipoDisplay=${tipoDisplay}&universityID=${universityID}&facultyID=${facultyID}&departmentID=${departmentID}`);
}

getAllTypeAvaliationByFaculty(tipoDisplay, universityID, facultyID){
    return http.get(`/departments?tipoDisplay=${tipoDisplay}&universityID=${universityID}&facultyID=${facultyID}`);
}

getAllCandidature(universityID, facultyID){
    return httpCandidatures.get(`/departments?universityID=${universityID}&facultyID=${facultyID}`);
}

getAllLogin(tipoDisplay){
    return http.get(`/departments?tipoDisplay=${tipoDisplay}`);
}

getAllLoginCandidatures(tipoDisplay){
    return httpCandidatures.get(`/departments?tipoDisplay=${tipoDisplay}`);
}
create(data){
    return  http.post("/departments", data);
}
getcode(id, tipoPedido, dadoPesquisa,  universityID,facultyID){
    return http.get(`/departments/${id}?tipoPedido=${tipoPedido}&dadoPesquisa=${dadoPesquisa}&universityID=${universityID}&facultyID=${facultyID}`)
}
// Search departments ID

getID(id){
    return http.get(`/departments/${id}`)
}
update(id, data){
    return http.put(`/departments/${id}`, data)
}
// delete departments

delete(id){
    return http.delete(`/departments/${id}`)
}

updateAvaliationType(id, data){
    return http.put(`/departments/updateavaliationtype/${id}`, data)
}

updateAvaliationTypeSmestrer1(id, data){
    return http.put(`/departments/avaliationtypeUpdateEcoleTerm1/${id}`, data)
}

updateAvaliationTypeSmestrer2(id, data){
    return http.put(`/departments/avaliationtypeUpdateEcoleTerm2/${id}`, data)
}

updateAvaliationTypeSmestrer3(id, data){
    return http.put(`/departments/avaliationtypeUpdateEcoleTerm3/${id}`, data)
}

updateAvaliationTypeSmestrer4(id, data){
    return http.put(`/departments/avaliationtypeUpdateEcoleTerm4/${id}`, data)
}
updateAvaliationTypeSmestrer5(id, data){
    return http.put(`/departments/avaliationtypeUpdateEcoleTerm5/${id}`, data)
}

updateTermTrimestrielOuSemestriel(id, data){
    return http.put(`/departments/updateTermTrimestrielOuSemestriel/${id}`, data)
}

}



export default new DepartamentoServices();
